import { useState, useCallback } from "react";

type ToastSeverity = "success" | "error" | "warning" | "info";

export interface ToastState {
  open: boolean;
  message: string;
  severity: ToastSeverity;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: "",
    severity: "info",
  });

  const showError = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "error",
    });
  }, []);

  const showSuccess = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "success",
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return {
    toast,
    showError,
    showSuccess,
    hideToast,
  };
};
